import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../core/services/auth.service';
import Swal from 'sweetalert2';
import { MatOption, MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-solicitar-acceso',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIcon,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatOption,
    MatSelectModule,
  ],
  templateUrl: './solicitar-acceso.html',
  styleUrl: './solicitar-acceso.scss',
})
export class SolicitarAcceso {
  constructor(
    private dialogRef: MatDialogRef<SolicitarAcceso>,
    private authService: AuthService,
  ) {}

  cerrar() {
    this.dialogRef.close();
  }

  enviarSolicitud() {
    if (this.requestForm.invalid) {
      this.requestForm.markAllAsTouched();
      return;
    }

    const form = this.requestForm.getRawValue();

    const data = {
      clinicName: form.clinicName,
      direccion: form.direccion,
      claveClinica: Number(form.claveClinica),
      nombre: form.nombre,
      apellidoPaterno: form.apellidoPaterno,
      apellidoMaterno: form.apellidoMaterno,
      email: form.email,
      password: form.password,

      cedula: [
        {
          tipoCedula: form.tipoCedula,
          cedula: Number(form.cedula),
        },
      ],
    };

    // console.log('Solicitud enviada:', data);

    this.authService.register(data).subscribe({
      next: (response: any) => {
        // console.log('Respuesta del backend:', response);

        Swal.fire({
          icon: 'success',
          title: 'Solicitud enviada',
          text: response.mensaje,
          showConfirmButton: false,
          timer: 2000,
        });

        this.dialogRef.close(data);
      },

      error: (error) => {
        // console.error('Error del backend:', error);

        Swal.fire({
          icon: 'error',
          title: 'Registro fallido',
          text: error?.error?.message ?? 'Ya existe ese email registrado',
          showConfirmButton: false,
          timer: 2000,
        });
      },
    });
  }

  private fb = inject(FormBuilder);

  requestForm = this.fb.group({
    clinicName: ['', Validators.required],
    direccion: ['', Validators.required],
    claveClinica: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
    nombre: ['', Validators.required],
    apellidoPaterno: ['', Validators.required],
    apellidoMaterno: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
    tipoCedula: ['', Validators.required],
    cedula: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
  });

  tiposCedula = [
    { valor: 'Licenciatura', nombre: 'Licenciatura' },
    { valor: 'Especialidad', nombre: 'Especialidad' },
    { valor: 'Maestría', nombre: 'Maestría' },
  ];

  mostrarPassword = false;
}
